import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { IInitStoreState } from '@core-lib/store/init-store/state';
import { FeatureName } from '@core-lib/store/init-store/feature';

export const selectState: MemoizedSelector<object, IInitStoreState> = createFeatureSelector<IInitStoreState>(FeatureName);

export const getIsInitLoading = (state: IInitStoreState): boolean => state.isInitLoading;
export const selectIsInitLoading = createSelector(selectState, state => getIsInitLoading(state));

export const getIsInitFinished = (state: IInitStoreState): boolean => state.isInitFinished;
export const selectIsInitFinished = createSelector(selectState, state => getIsInitFinished(state));
